import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar'
import Scrollbar from '../../components/scrollbar'
import BankDetailForm from '../../components/BankDetailForm/index';

const BankDetailPage = () => {
    return (
        <Fragment>
            <Navbar />
            <div id="Contact" className="contact-area">
                <div className="container">
                    <div className="contact-content">
                        <h2 style={{ fontSize: '26px', marginBottom: '26px' }}>Bank Information</h2>
                        <div className="contact-form">
                            <BankDetailForm />
                        </div>
                    </div>
                </div>
            </div>
            <Scrollbar />
        </Fragment>
    )
};
export default BankDetailPage;